module.exports = __webpack_public_path__ + "img/yhzc.734941aa.png";